export default __webpack_public_path__ + "static/media/CA_00.90caf73d.png";